
    <td class="align-middle">
        <div class="div-state" [ngClass]="'state-' + colorCode">&nbsp;</div>
    </td>

    <td>{{ payment.type }}</td>
    <td align="center">{{ payment.receiver }}</td>
    <td align="center">{{ payment.amount | number: '1.2-2' }}</td>
    <td align="center">{{ payment.received | number: '1.2-2' }}</td>

    <td align="center" class="align-middle">
        <strong><span [ngClass]="'state-' + colorCode">{{ payment.received_percentage | number: '1.2-2' }}</span></strong>
    </td>

    <td align="center">{{ payment.outstanding | number: '1.2-2' }}</td>
    <td align="center">{{ payment.paid | number: '1.2-2' }}</td>
    <td align="center">{{ payment.open }}</td>
    <td align="center">{{ payment.booking_date | drDate }}{{ !payment.booking_date ? '-' : '' }}</td>
    <td align="center">{{ payment.payment_target | drDate }}{{ !payment.payment_target ? '-' : '' }}</td>
